export type LinkPart = { text: string } | { href: string; text: string };
const URL_RE = /https?:\/\/[^\s<>"']+/g;
const count = (s: string, ch: string) => s.split(ch).length - 1;
function trimUrl(url: string): string {
 for (;;) { const c = url[url.length - 1];
 if (c && '.,!?;:'.includes(c) || c === ')' && count(url, ')') > count(url, '(') || c === ']' && count(url, ']') > count(url, '[')) { url = url.slice(0, -1); continue; } return url; }
}
export function linkify(text: string): LinkPart[] {
 const out: LinkPart[] = []; let last = 0;
 for (const m of text.matchAll(URL_RE)) { const url = trimUrl(m[0]), start = m.index!;
 try { const u = new URL(url); if (!['http:', 'https:'].includes(u.protocol)) continue; } catch { continue; }
 if (start > last) out.push({ text: text.slice(last, start) }); out.push({ href: url, text: url }); last = start + url.length; }
 if (last < text.length) out.push({ text: text.slice(last) }); return out.length ? out : [{ text }];
}
